import News from '../components/news.svelte'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const { $ } = window
export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		
		let $newsWrap = $('#news-wrap')
		if ($newsWrap.length) {
			new News({
				target: $newsWrap[0]
			})
		}
		
		gsap.set('.news-featured .news-post', {y: 32})
		
		let tl = gsap.timeline()
		$('.h-underline').each((idx, el) => {
			tl.to(el, {
				scrollTrigger: {
					trigger: el,
				},
				y: 0,
				duration: 0.35,
				opacity:1
			})
		})
		tl.to('.news-featured .news-post', {opacity: 1, y: 0, duration: 0.35, stagger: 0.1, ease:'power1.out'})
		// setTimeout(() => {
		// 	gsap.set('#news-insight', {y: 32})
		// 	tl.to('#news-insight', {scrollTrigger: { trigger: '#news-insight'}, delay:1, opacity: 1, y: 0, duration: 0.35, ease:'power1.out'}, '-=0.7')
		// }, 200)
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		
		const catIndicator = document.querySelector('.current-indicator')
		// setTimeout(() => {
		$('.cat-nav li').hover(function(e) {
			let el = $(e.target).find('a')
			if (!el.length) return
			el = el[0]
			// if (el.length)
			// 	el = el[0]
			// else
			// 	el = $(e.target).find('span')[0]
			catIndicator.style.width = `${el.offsetWidth}px`
			catIndicator.style.left = `${el.offsetLeft}px`
		}, function(){
			let el = $('.cat-nav li span')[0]
			catIndicator.style.width = `${el.offsetWidth}px`
			catIndicator.style.left = `${el.offsetLeft}px`
		})
	},
}
